import * as React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
/* eslint-disable */
import AirlineCompanyLogo from '../airlineCompanyLogo/AirlineCompanyLogo';
import FlightInfoTime from '../flightInfoTime/FlightInfoTime';
import i18n from 'i18n-react';
import './FlightInfo.css';
import Moment from 'moment';
import { Currency } from '../../const/CurrencyType';
import FormatValue from '../../utils/FormatValue';

const propTypes = {
  flight: PropTypes.any,
  name: PropTypes.any,
  className: PropTypes.any,
  isSelected: PropTypes.any,
  selectable: PropTypes.any,
  onChangeCheckbox: PropTypes.any,
  isDepartureFlight: PropTypes.any,
  isPointsPlusMoney: PropTypes.any,
  compareDate:PropTypes.bool
};

function FlightInfo(props) {
  const flight = props.flight;
  return (
    <div
      data-test={props.name}
      className={`FlightInfo padding-eight-horizontal-32 ${props.className} ${props.isSelected &&
        'FlightInfo__isSelected'}`}>
      <Row className="padding-eight-top-24 ">
        <Col>
          <div data-test="flightLabel" className="text-md text-science-blue FlightInfo__flex">
            {props.selectable && (
              <input
                type="checkbox"
                className="FlightInfo__checkbox"
                onChange={props.onChangeCheckbox}
              />
            )}
            {getLabel(props.isDepartureFlight)}
          </div>
        </Col>
      </Row>
      <Row className="text-warm-grey-two text-lg padding-eight-top-4">
        <Col span={10}>
          <div data-test="airportLabel" className="FlightInfo__airportInfo">
            {flight.originAirportName} ({flight.originAirport}){' '}
            <span className="text-silver">{i18n.translate('features.flightInfo.to')}</span>{' '}
            {flight.finalDestinationName} ({flight.finalDestination})
          </div>
        </Col>
        <Col span={6}>
          <div data-test="flightDate" className="FlightInfo__flightDate text-lg">
            {Moment(props.flight.departureDate, 'DD/MM/YYYY').format('ddd, D MMM YYYY')}
          </div>
        </Col>
      </Row>

      <div className="FlightInfo__hr bg-light-gray" />

      <Row className="padding-eight-vertical-8">
        <Col span={6} className="FlightInfo__airlineCompanyLogo">
          <AirlineCompanyLogo flights={flight.flightGroup} />
        </Col>
        <Col span={10}>
          <FlightInfoTime
            hasAirportChange={flight.hasExchangeAirport}
            isDepartureFlight={props.isDepartureFlight}
            departureFlight={{
              time: flight.departureTime,
              airportSign: flight.originAirport
            }}
            arrivalFlight={{
              plusDays: flight.dateVariation,
              time: flight.finalArrivalTime,
              airportSign: flight.finalDestination
            }}
            flightGroup={flight.flightGroup}
          />
        </Col>
        <Col span={8} className="FlightInfo__cabinInfo">
        {!props.isPointsPlusMoney ? renderOnlyPoints() : renderPointsPlusMoney()}
          <Row>
            <div
              data-test="cabin"
              className="FlightInfo__cabinInfo__cabinType text-warm-grey text-sm">
              {getCabin(flight.category)}
            </div>
          </Row>
        </Col>
      </Row>
    </div>
  );

  function renderOnlyPoints() {		
		return (
			<div>
				<Row>
					<div
						data-test="totalPoints"
						className="FlightInfo__cabinInfo__points text-brownish-grey"
					> 
						{FormatValue.formatPoints(getValueByCurrency(Currency.POINTS, flight.total))}
					</div>
				</Row>
				<Row>
					<div className="FlightInfo__cabinInfo__tudoAzul text-warm-grey-two text-sm">
						{i18n.translate(`features.flightInfo.pointsAzul`)}
					</div>
				</Row>
			</div>
		)
	}

	function renderPointsPlusMoney() {   
		return (
			<div>
				<Row>
					<div>
						<span className={ !props.compareDate ? "FlightInfo__cabinInfo__pointsPlusMoneyDisabled" : 'FlightInfo__cabinInfo__pointsPlusMoney'}>{FormatValue.formatPoints(getValueByCurrency(Currency.POINTS, flight.total))}</span> 
            <span className={ !props.compareDate ? "FlightInfo__cabinInfo__infopartAmountDisabled" : 'FlightInfo__cabinInfo__infopartAmount'}>{' ' + i18n.translate('pointsPlusMoney.flightInfo.points')}
						{i18n.translate('pointsPlusMoney.flightInfo.partAmount')}  {FormatValue.formatAmount(getValueByCurrency(Currency.MONEY, flight.total))}</span>
					</div>
				</Row>
			</div>
		)
	}

	function getValueByCurrency(currency, total) {
		const result = total.filter((value) => value.currency === currency)[0];
		return result ? result.value : { value: 0 }
	}

}



function getLabel(isDepartureFlight) {
  return isDepartureFlight
    ? i18n.translate('features.flightInfo.departure')
    : i18n.translate('features.flightInfo.arrival');
}
function getCabin(cabin) {
  return cabin.toString().toUpperCase() === 'ECONOMY'
    ? i18n.translate('features.flightInfo.cabinEconomy')
    : i18n.translate('features.flightInfo.cabinBusiness');
}

FlightInfo.propTypes = propTypes;

export default FlightInfo;



// WEBPACK FOOTER //
// ./src/components/flightInfo/FlightInfo.jsx